export type Units = "cm" | "in" | "mm" | "m";

export type Dimension = {
  width: number;
  height: number;
  unit: Units;
};

export const mm2in = (n: number) => n / 25.4;
export const cm2in = (n: number) => n / 2.54;
export const in2cm = (n: number) => n * 2.54;
export const in2mm = (n: number) => n * 25.4;
export const cm2mm = (n: number) => n * 10;
export const mm2cm = (n: number) => n / 10;

export const toUnits = (units: Units, n: number) => {
  if (units === "mm") {
    return n.toString();
  }

  return n.toFixed(units === "cm" ? 0 : 1);
};

export const convert = (fromUnits: Units, toUnits: Units, n: number) => {
  if (fromUnits === "mm") {
    if (toUnits === "cm") {
      return mm2cm(n);
    } else if (toUnits === "in") {
      return mm2in(n);
    }

    return n;
  }

  if (fromUnits === "cm") {
    if (toUnits === "mm") {
      return cm2mm(n);
    } else if (toUnits === "in") {
      return cm2in(n);
    }

    return n;
  }

  if (fromUnits === "in") {
    if (toUnits === "mm") {
      return in2mm(n);
    } else if (toUnits === "cm") {
      return in2cm(n);
    }

    return n;
  }

  return n;
};
